import React from 'react';

/**
 * Simple stat box used across holistic dashboard screens.
 */
export const StatBox: React.FC<{ label: string; value: string; color?: string; large?: boolean }> = ({ label, value, color = 'text-gray-900', large }) => (
  <div className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm">
    <p className="text-xs text-gray-500 mb-1">{label}</p>
    <p className={`${large ? 'text-2xl' : 'text-xl'} font-bold ${color}`}>{value}</p>
  </div>
);

/**
 * Term-based info card (Term 1 / Term 2 observations).
 * Used in Behavior, Peer, and other profile tabs.
 */
export const TermCard: React.FC<{ title: string; items: { term: string; text: string }[] }> = ({ title, items }) => (
  <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
    <h4 className="text-sm font-semibold text-gray-700 mb-3">{title}</h4>
    <div className="space-y-3">
      {items.map((item, i) => (
        <div key={i}>
          <span className="inline-block text-[10px] font-semibold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded mb-1">{item.term}</span>
          <p className="text-sm text-gray-600">{item.text}</p>
        </div>
      ))}
    </div>
  </div>
);
